import type { RouterOutputs } from '@klear/ui/lib/trpc'
import type { KycModel } from '@klear/kyc/kyc'
import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

export function useKyc(): {
  kyc: KycModel | null | undefined
  kycLoading: boolean
  kycError: ReturnType<typeof trpc.kyc.get.useQuery>['error']
  stripeCreate: () => Promise<RouterOutputs['stripe']['createAccount']>
  stripeGetVerificationLink: () => Promise<RouterOutputs['kyc']['getAccountLink']>
  stripeRefreshStatus: () => Promise<KycModel>
} {
  const {
    data: kyc,
    isLoading: kycLoading,
    error: kycError
  } = trpc.kyc.get.useQuery(undefined, {
    retry: false
  })

  const invalidateQueries = ['trader.get', 'kyc.get']

  const stripeCreateMutation = useMutationWithToast(
    trpc.stripe.createAccount.useMutation,
    createToastConfig('Stripe Account', 'create'),
    {
      invalidateQueries
    }
  )

  const stripeRefreshStatusMutation = useMutationWithToast(
    trpc.kyc.refreshAccountStatus.useMutation,
    createToastConfig('Stripe Account Status', 'update'),
    {
      invalidateQueries
    }
  )

  const stripeGetVerificationLinkMutation = useMutationWithToast(
    trpc.kyc.getAccountLink.useMutation,
    createToastConfig('Verification Link', 'get')
  )

  const stripeCreate = () => stripeCreateMutation.mutateAsync()

  const stripeRefreshStatus = () => stripeRefreshStatusMutation.mutateAsync()

  const stripeGetVerificationLink = () => stripeGetVerificationLinkMutation.mutateAsync()

  return {
    kyc,
    kycLoading,
    kycError,
    stripeCreate,
    stripeGetVerificationLink,
    stripeRefreshStatus
  }
}
